export default {
  common: {
    colon: ': ',
    comma: ', ',
    slash: ' / ',
    yes: '是',
    no: '否',
    cancel: '取消',
    confirm: '确认',
    back: '返回',
    backToTickets: '返回票券列表',
    backToTicketDetails: '返回票券明细',
    day: '天',
    hour: '小时',
    min: '分',
    second: '秒'
  },
  views: {
    limousine: {
      statusHeading: {
        INVALID: '无效',
        AWAITING: '使用前',
        UNUSED: '使用前',
        USABLE: '使用前',
        IN_USE: '使用中',
        USED: '已使用',
        EXPIRED: '已过期',
        DISTRIBUTED: '已分发',
        RETURNED: '已返还'
      },
      unavailable: '此票\n无法使用',
      usedInfo: '已使用票券信息',
      gateTime: '使用时间 {{date}}',
      passengerCount: '{{title}} {{count}}人',
      adultUnitTitle: '成人',
      childUnitTitle: '儿童',
      childBadge: '童',
      inUseClockNote: '可在30分钟内检票',
      journeyInfo: '乘车信息',
      from: 'FROM',
      to: 'TO',
      expirationDate: 'EXPIRATION DATE / 有効期限',
      route: 'ROUTE / 路線',
      rateType: 'RATE TYPE / 料金区分',
      amount: '{{amount}}日元',
      status: 'STATUS / ステータス',
      usedStampAlt: '已使用',
      gate: '使用票券',
      gateDrawerInstruction: '请在点击“使用票券”按钮后的30分钟内出示票券。',
      useTicket: '使用票券',
      outsideAvailablePeriod: '当前不在票券可使用期间。',
      availablePeriod: '可使用期间：',
      availableFrom: '{{date}} 起',
      availableTo: '至 {{date}}',
      history: '乘车记录',
      availableRoutes: '查看可用路线',
      bookingInfo: '预订信息',
      bookingId: 'Booking ID：',
      purchasedAt: '购买时间：{{date}}'
    },
    linkTrain: {
      title: '新干线二维码车票',
      unavailable: '暂时无法显示车票。',
      instructions: '使用说明',
      notice1: '※请直接使用二维码进站，无法兑换纸质车票。',
      notice2:
        '※每位乘客都有唯一的乘车二维码。为确保顺利出行，建议提前将带有二维码的车票分别发送给每位同行者。为避免网络通信问题，建议提前截图或打印。'
    },
    common: {
      submit: '发送',
      resend: '再次发送',
      cancel: '取消',
      confirm: '确认',
      tickets: '票券列表',
      copyBtn: '复制网址',
      recommendBrowserTips: '目前不支援您的浏览器。请使用推荐的浏览器打开链接。'
    },
    voucher: {
      title: '数码凭证',
      bookingId: '订单编号',
      ticketInfo: '票券信息',
      bookingInfo: '预订信息',
      bookingDetails: '订单详情',
      printable: '打印用凭证',
      participation: '集合或兑换地点说明',
      inclusion: '费用包含',
      restrictions: '参加制限',
      requiredAttire: '须携带的物品/服装',
      requirements: '参加时必需的其他事项',
      other: '备注',
      localContact: '当地联络方式',
      cancellation: '取消政策',
      clickUrl: '请点击该链接使用票券',
      unitAdditionalLabel: '{{unitTitle}}{{unitIndex}} 追加预订信息'
    },
    booking: {
      details: '订单详情',
      bookingId: 'Booking {{id}}',
      history: '使用记录',
      bookedDate: '订购日',
      participationLocations: '参加地点',
      participationLocationKind: {
        MAP_OF_MEETING_POINT: '地点说明',
        NOTE_OF_LOCATION_AND_DIRECTION: '地点说明与前往方式',
        LANDMARKS_TO_MEETING_POINT: '周边参考路标',
        PICK_UP_CAR: '迎接车辆',
        PICK_UP_GUIDE: '迎接人员',
        ITINERARY: '行程',
        PARKING: '关于停车'
      },
      ticketType: {
        CODE_CPM: '展示二维码',
        CODE_MPM: '扫描二维码',
        BARCODE_CPM: '展示条形码',
        SELF_REDEMPTION: '展示票券',
        SIMPLE_VOUCHER: '展示票券'
      },
      inclusion: '费用包含',
      restrictions: '参加限制',
      requirements: '参加之前和期间的必要事项',
      attireItems: '须携带的物品/服装',
      otherInfo: '备注/其他',
      cancellationPolicy: '取消政策'
    },
    otp: {
      title: '一次性密码',
      tips1:
        '您的访问环境已更改。 \n 为确保安全，系统将向您发送一次性密码以进行验证。',
      tips2: '请注册您的电子邮箱地址，以便接收一次性密码。',
      inputOTPCode: '请输入邮件中所记载的一次性密码。',
      sendCode: '已将一次性密码发送至{{email}}，请确认。',
      invalidEmail: '此电子邮箱无效。',
      inputEmail: '请输入您的电子邮箱。',
      inputPassword: '请输入一次性密码。',
      sendOTP: '发送一次性密码'
    },
    ticket: {
      status: {
        INVALID: '无效',
        AWAITING: '使用可能期間前',
        UNUSED: '使用前',
        USABLE: '可使用',
        IN_USE: '使用中',
        USED: '已使用',
        EXPIRED: '已过期',
        DISTRIBUTED: '已分发',
        RETURNED: '已返还'
      },
      subStatus: {
        ENTERED: '已进站',
        EXITED: '已出站',
        INITIAL_STATION_CANCELLED: '撤销进站'
      },
      nowTime: '当前时间',
      startTime: '开始时间',
      QRCodeExpirationRemainingTime: '二维码剩余有效期',
      QRCodeAwaiting: '票券可用期间开始后，将显示二维码',
      screenShotTips: '仅持二维码的截图恕无法进站。',
      showScreenToStaff: '请向工作人员出示此画面。',
      scanFailedTips: '扫码失败时请点击二维码刷新。',
      instruction: '使用说明',
      usedAt: '使用日',
      availablePeriod: '使用可能期间',
      bookingId: '订单编号',
      startUsing: '开始使用',
      startUsingTips: '确认开始使用电子票吗？',
      startUsingWarn: '*使用开始的同时，有效期开始。',
      selfRedemptionOptionPresetPlaceholder: '使用选项选择',
      distributeTicket: '分发',
      distributedTicket: '已分发',
      distributeTicketTips:
        '若无法使用分发票券按钮复制链接，请直接复制以上链接并发送给同行者。',
      reDistributeTicket: '重新分发',
      reDistributeTips: '※仅同行者票券处于“未使用”状态时可重新分发。',
      reDistributeTips2: '※重新分发后，原链接即失效。',
      copyLinkSuccess: '已复制链接',
      use: '使用',
      confirmUse: '确认使用内容',
      useTicket: '使用<span>{{count}}</span>张',
      issueTicketTips: '请在工作人员面前使用',
      issueTicketNotes: '※使用后不可取消',
      undo: '取消使用',
      redeem: '使用开始',
      thanks: '谢谢您的使用',
      second: '{{count}}秒',
      expirationDate: '有効期限',
      supplier: '供应商',
      participatorName: '参加者姓名',
      validPeriod: '使用后有效期',
      fixedTime: '{{day}} 天 (最终日到当地时间{{time}}为止)',
      enableCamera: '请允许本服务使用相机权限。',
      qrTip: '将二维码放入框内，即可自动扫描',
      accessDeniedTip: '无法打开摄像头',
      manualVerify: '手动验证',
      unit: '{{unit}} {{index}}',
      afterUse: '使用后',
      participationDate: '参加日期',
      participationTime: '开始时间'
    },
    confirmUse: {
      title: '是否开始使用？',
      usedTitle: '已使用！',
      tips: '请务必在工作人员面前滑动。如提前使用将无法入场。',
      usedTips: '票券无法重复使用。祝您旅途愉快！',
      lockedText: '请在工作人员面前滑动',
      unlockText: '已使用',
      returnText: '返回',
      closeText: '关闭弹窗'
    },
    history: {
      title: '使用记录'
    },
    advanced: {
      title: '站务员功能',
      success: '站务员作业已完成。'
    },
    apiErrors: {
      baseError: '检测到有错误发生。',
      clientError: 'API 请求存在错误。',
      serverError: '服务器无法完成该请求。',
      connectionError: '与服务器的连接失败。请检查网络设置后重试。',
      requestError: 'API 请求存在错误。'
    }
  }
};
